// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"U1-z","displaySixCardTiles":"V1-z"};